import { useContext } from "react";
import { KpiContext } from "../../contexts/kpiContext";

const useKpiContext = () => {
  const value = useContext(KpiContext);
  return value;
};

export default useKpiContext;
